import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_USER_CPD_PROGRESS_REPORT: (filter) => ({ filter }),
    API: {
      GET_USER_CPD_PROGRESS_REPORT: apiResourceActionCreator('report')
    }
  }
})

export const apiAction = (authToken, filter) => commonApiActions.authenticated.get(`${API_ENDPOINT}/reports/users/cpd-progress?${queryString.stringify(filter)}`, authToken, action.admin.api.getUserCpdProgressReport)

function* getUserCpdProgressReport(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.filter));
}

const configuration = {
  name: 'getUserCpdProgressReport',
  action: action,
  sagas: getUserCpdProgressReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingReport: true
    }),
    success: (state, action) => {
      const { total, skip, take } = action.payload.report;

      const updatedUserStats = (!state.report || !state.report.userCpdProgressReport || skip === 0) ?
        action.payload.report.usersCpdStats : [
          ...state.report.userCpdProgressReport.usersCpdStats,
          ...action.payload.report.usersCpdStats
        ]

      const updatedUsersCpdCategorySearchTiles = (!state.report || !state.report.userCpdProgressReport || skip === 0) ?
        action.payload.report.usersCpdCategorySearchTiles : [
          ...state.report.userCpdProgressReport.usersCpdCategorySearchTiles,
          ...action.payload.report.usersCpdCategorySearchTiles
        ]

      return {
        ...state,
        isFetchingReport: false,
        report: {
          ...(state.report || {}),
          userCpdProgressReport: {
            total,
            skip,
            take,
            usersCpdStats: updatedUserStats,
            usersCpdCategorySearchTiles: updatedUsersCpdCategorySearchTiles
          }
        }
      };
    },
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getUserCpdProgressReport.js